var VisualBlockColors;
(function (VisualBlockColors) {
    VisualBlockColors["RED"] = "semantic.illustration.foreground6";
    VisualBlockColors["YELLOW"] = "semantic.illustration.background9";
    VisualBlockColors["GREEN"] = "semantic.illustration.background7";
    VisualBlockColors["BLUE"] = "semantic.illustration.background8";
})(VisualBlockColors || (VisualBlockColors = {}));
var VisualBlockSizes;
(function (VisualBlockSizes) {
    VisualBlockSizes["SM"] = "sm";
    VisualBlockSizes["MD"] = "md";
    VisualBlockSizes["LG"] = "lg";
    VisualBlockSizes["XL"] = "xl";
})(VisualBlockSizes || (VisualBlockSizes = {}));
var CaretSide;
(function (CaretSide) {
    CaretSide["TOP"] = "top";
    CaretSide["BOTTOM"] = "bottom";
    CaretSide["LEFT"] = "left";
    CaretSide["RIGHT"] = "right";
})(CaretSide || (CaretSide = {}));
export { VisualBlockColors, VisualBlockSizes, CaretSide };
//# sourceMappingURL=VisualBlock.types.js.map